import Vue from 'vue';
import { portfolioService} from '@/services/services';
import  QuoteService  from '@/services/Quotes';
import {error} from '@/utils/log'
import {extractJsonDate, formatDate, removeDateStrTimezone} from "../../utils/formatters";
import { byID, bySymbol } from '../common';
import { OrderClass } from '../../domain/types';
import TradingBlockRemote from '../../services/TradingBlockRemote';


export default {


    async getPortfolioCompanies({state, commit, dispatch}){
          clearTimeout(state.timer);
          commit('setRefreshing', false);
          commit('setPortfolioSymbolsLoad', true);
         
            await portfolioService.getPortfolioSymbols().then((resp)=>{
                if (resp.Items != null){
                    resp.Items.forEach((it)=>{
                      if (typeof it.PredictionDate === "string")
                        it.PredictionDate = it.PredictionDate? extractJsonDate(it.PredictionDate).toLocaleDateString():'';
                      if (it.StartValue!=='null'){
                        it.StartValue = parseFloat(it.StartValue);
                      }
                      if (it.StartPricePerShare!=='null') {
                        it.StartPricePerShare = parseFloat(it.StartPricePerShare);
                      }
                      if (it.PredictionOpen === 0){
                        it.FullUpdatedNeeded = true;
                      }
                    });
                    commit('insertLoadedPortfolio', resp.Items);
                    for (let i = 0; i < resp.Items.length; i++) {
                      dispatch('updateColor', i);
                    }
                    commit('setAllPredictionsLoading');
                    dispatch('updatePortfolioPredictions');
                    dispatch('updatePortfolioRealtime', {tb: true});
                    //commit('QUOTES_SUBSCRIBE', resp.Items.map(o=> {return {OrderClass:1, Symbol: o.Symbol}}), {root:true});

                } else {
                    if(resp.Message) commit('appendLog', {message: resp.Message,level: 'info'}  )
                }
                commit('setPortfolioSymbolsLoad', false);
                dispatch('persist');
            }).catch((err)=>{
                error.log('Failed getPortfolioSymbols with ' + err);
                commit('setPortfolioSymbolsLoad', false);
            });
    },
    switchEmail({state, commit}, payload){
        byID(state, payload, (index)=>{
            let check = { Email: !payload.Email };    
            portfolioService.setSymbolEmailSetting(payload.ID, check.Email).then(()=>{
                commit('updatePortfolioSymbolFields', {ID:payload.ID, update:check });
            });
        });
    },
    async updateSymbol({state, commit, dispatch}, payload) {
        let dat;
        commit('setRowPredictionLoading', payload);
        if (payload.FullUpdatedNeeded)
        {
            dat = await portfolioService.recalculateSymbol(payload.ID, true);
            commit('setRowPredictionLoaded', {ID: payload.ID});
        }else if (payload.OneDayPredictionNeeded){
            dat = await portfolioService.recalculateSymbol(payload.ID, false);
            commit('setRowPredictionLoaded', {ID: payload.ID});
        }else {
            commit('setRowPredictionLoaded', {ID: payload.ID});
            return;
        }

        dat.PredictionDate = dat.PredictionDate? extractJsonDate(dat.PredictionDate).toLocaleDateString():'';

      let filtered ={  };
        filtered.ActualShares = dat.ActualShares;
        filtered.ActualPricePerShare= dat.ActualPricePerShare;
        filtered.ActualValue= dat.ActualValue;
        filtered.ActualNetChange= dat.ActualNetChange;

      if (!dat.DailyError){
          filtered.PredictionClose10Day=dat.PredictionClose10Day;
          filtered.PredictionError = dat.PredictionError;
          filtered.PredictionHigh = dat.PredictionHigh;
          filtered.PredictionLow = dat.PredictionLow;
          filtered.PredictionOpen = dat.PredictionOpen;
          filtered.PredictionClose = dat.PredictionClose;
          commit('updateDailyFields', {ID:payload.ID, update:{
            PredictionClose10Day: dat.PredictionClose10Day,
            PredictionError: dat.PredictionError,
            PredictionHigh: dat.PredictionHigh,
            PredictionLow: dat.PredictionLow,
            PredictionOpen: dat.PredictionOpen,
            PredictionClose: dat.PredictionClose,


          } });      

      } else {
          filtered.DailyError = dat.DailyError;
          commit('appendLog', {message: 'Daily Error for ' + payload.Symbol, level: 'error'});
      }
      if (payload.FullUpdatedNeeded){
        if (!dat.MonthError){
          filtered.EstValue = dat.EstValue;
          filtered.Prediction1Month = dat.Prediction1Month;
          filtered.Prediction2Month = dat.Prediction2Month;
          filtered.Prediction3Month = dat.Prediction3Month;
          commit('updateMonthFields', {ID:payload.ID, update:{
              EstValue: dat.EstValue,
              Prediction1Month: dat.Prediction1Month,
              Prediction2Month: dat.Prediction2Month,
              Prediction3Month: dat.Prediction3Month
            } });
        } else {
          filtered.MonthError = dat.MonthError;
          commit('appendLog', { message: 'Month Error for ' + payload.Symbol, level: 'error' });
        }
      }

      dispatch('updateColor', state.items.findIndex((o)=>o.ID === payload.ID));
    },

    // fallback mechanism: TB WS-> TB QUOTES //-> SFT
    // symbol becomes fallback until page refresh
    addFallbackSymbol({state, commit}, payload){
      if (state.fallbackSymbols.indexOf(payload)<0)
        state.fallbackSymbols.push(payload);
    },
    clearFallbackSymbos({state}) {
      state.fallbackSymbols = [];
    },
    removeFallbackSymbol({state}, payload) {
      const pos = state.fallbackSymbols.indexOf(payload);
      pos > 0 && Vue.delete(state.fallbackSymbols, pos);
    },

    deleteSymbol({state, commit, dispatch}, payload){
        byID(state, payload, (index)=>{
          if (payload.force_delete || confirm('Do you want to delete symbol ' + state.items[index].Symbol +' from portfolio?')) {
            portfolioService.deleteSymbol(payload.ID).then((res) => {

              dispatch('persist');
              commit('QUOTES_UNSUBSCRIBE',  [{ Symbol: payload.Symbol}], {root:true});
              dispatch('removeFallbackSymbol', payload.Symbol);
              commit('removePortofolioSymbol', { ID: payload.ID });
            }).catch((err) => {
              commit('appendLog', "Can't delete symbol from portfolio");
              console.log(JSON.stringify(err));
              // dispatch('persist');
              // commit('removePortofolioSymbol', { ID: payload.ID });
            });
          }
        });
    },
    persist({state, commit, dispatch}, payload){
        // if (window.sessionStorage ) {
        //     sessionStorage.setItem('portfolio_items', JSON.stringify(state.items));
        // }
    },
    rehydrate({state, commit, dispatch}, payload){
        // if (window.sessionStorage ) {
        //
        //     state.items = JSON.parse(sessionStorage.getItem('portfolio_items'));
        //     if (state.items && state.items.length>0){
        //         commit('setAllPredictionsLoaded');
        //         commit('setPortfolioSymbolsLoad', false);
        //         return;
        //     }
        //
        // }
        if (!state.items || state.items.length==0)
            dispatch('getPortfolioCompanies');
        else
            commit('setPortfolioSymbolsLoad', false);
        
    },
    async updatePortfolioPredictions({state, commit, dispatch}) {
      try {
        // console.log("should update" + state.items.length + " symbols");
        for (let index of state.items.keys()) {
          // console.log("update prediction for" + state.items[index].Symbol)
          await dispatch('updateSymbol', state.items[index], index);
        }
        commit('clearLog');
        dispatch('persist');

      } catch (e) {
        commit('appendLog', {message: 'Stopped because of ' + e, level: 'error'});
      }
    },

    updateColor({state, commit}, payload) {
      let index = payload;
      const row = state.items[index];
      const lowError = 0.25 * row.PredictionError * row.PredictionLow;
      const highError = 0.25 * row.PredictionError * row.PredictionHigh;
      if (row.ActualPricePerShare == 0) {
        commit('setColoredRow', {index, color:''});
      } else if (row.ActualPricePerShare <= row.PredictionLow + lowError){
        console.log("Boolish "+row.Symbol + ": " + row.ActualPricePerShare.toFixed(2) + "$<=" + row.PredictionLow.toFixed(2) + "+" + lowError.toFixed(2));
        commit('setColoredRow', {index, color: 'row-low-corridor'});//boolish
      } else if (row.ActualPricePerShare >= row.PredictionHigh - highError){
        console.log("Bearish "+row.Symbol + ": " + row.ActualPricePerShare.toFixed(2)+ "$>=" + row.PredictionHigh.toFixed(2) + "-" + highError.toFixed(2));
        commit('setColoredRow', {index, color:'row-high-corridor'});//bearish
      } else {
        commit('setColoredRow', {index, color:''});
      }
    },
    updateRealtimeBySymbol ({state, commit, dispatch}, payload) {
      bySymbol(state, payload, (index)=> {

        let update = {
          ActualNetChange: payload.ActualNetChange,
          ActualPricePerShare: payload.last_trade_price,
          ActualValue: payload.last_trade_price*state.items[index].StartShares
        };
        commit('updateRealtimeFields', {ID:state.items[index].ID, update, from: payload.from });
        dispatch('updateColor', index);

      });
    },


    // manual and fallback posrtfolio prices update
    async updatePortfolioRealtime({state, commit, dispatch}, payload)
    {

      function notifyOnceAboutLogin(){
        if (!state.notified_tb_login) {
          state.notified_tb_login = true;
          commit('appendLog', {
            message: 'Please login at stocks page to tradingblock to use TradingBlock quotes.',
            level: 'info',
          });
        }
      }

      function handleQuoteServiceError(exc) {
        if (exc === 200) {
          notifyOnceAboutLogin();
        } else
          commit('appendLog', { message: 'Tradingblock response:' + exc, level: 'info' });
      }

      let tb = TradingBlockRemote.authenticated;

      if (!tb) // no cookies
        notifyOnceAboutLogin();
      // load from tradingblock if logged into it or load from sft
      if (tb){
        const requestSymbols = payload.fallback ? state.fallbackSymbols :  state.items.map(o=>o.Symbol);

        if (!requestSymbols || requestSymbols.length==0)
          return;

        try {
          const prices = await QuoteService.loadFromTradingBlock(requestSymbols);
          prices.forEach((update) => {
            let index = state.items.findIndex((o) => o.Symbol === update.Symbol);
            if (index >= 0) {
              const row = state.items[index];

              const filtered = {
                ActualPricePerShare: update.LastTradePrice,
                ActualValue: update.LastTradePrice * row.StartShares,
                ActualNetChange: update.NetChange,
              };

              commit('updateRealtimeFields', { ID: state.items[index].ID, update: filtered, from:'tb_api' });

              dispatch('updateColor', index);
            }
          });

          return;
        } catch (exc) {
          handleQuoteServiceError(exc);
          //window.GotoLoginScreen();
          tb = false;
        }
      }
      if (!tb){
        //commit('setLoadingQuotes', true);

        if (payload && payload.fallback && state.fallbackSymbols.length==0)
          return;

        let prices = await portfolioService.GetCompaniesPrices();
        prices.forEach((update) => {
          const index = state.items.findIndex((o) => o.ID === update.ID);
          const isAllowed = !payload || !payload.fallback || state.fallbackSymbols.indexOf(update.Symbol);

          if (index >= 0 && isAllowed) {
            const row = state.items[index];

            const filtered = {
              ActualPricePerShare: update.ActualPricePerShare,
              ActualValue: update.ActualValue,
              ActualNetChange: update.ActualNetChange,
            };

            if (filtered.ActualPricePerShare==0){
              commit('appendLog', {message: 'SFT returned 0 realtime price for ' + row.Symbol});
            } else
              commit('updateRealtimeFields', { ID: state.items[index].ID, update: filtered, from:'sft' });
            dispatch('updateColor', index);
          }
        });
        //commit('setLoadingQuotes', false);
    }



      if (state.refreshing) {
        const timerHandle = setTimeout(() => dispatch('updatePortfolioRealtime',{tb: true}), window.PortfolioQuoteRate || 180000);
        commit('setTimer', timerHandle);
      }

    },
    switchTimer({state, commit, dispatch}) {
        clearTimeout(state.timer);
        commit('setRefreshing', !state.refreshing);
        if (state.refreshing && !TradingBlockRemote.authenticated)
            commit('setTimer', setTimeout( dispatch('updatePortfolioRealtime'), 180000));
    },

    async editPortfolioSymbol({state, commit, dispatch}, payload){
      let resp = await portfolioService.editSymbol(payload);

      dispatch('selectEditSymbol', null);
      dispatch('getPortfolioCompanies');
    },

    SelectedDelete({state,commit, dispatch}, payload){
      state.items.filter(o=>o.selected).forEach(o=>{
        o.force_delete = true;
        dispatch('deleteSymbol', o);
      });
    },
    SelectedPlace({state,commit, dispatch, payload}){
      state.items.filter(o=>o.selected).forEach(o=>{

      });
    },
    ShowBatchForm({state, commit, dispatch}, payload) {
      dispatch('balance/Load', null, {root:true});
      state.showBatchPlaceForm = true;
    },
}
